import './style.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import About from './components/About';
import Footer from './components/Footer';
import Skills from './components/Skills';
import image from './background/klim-musalimov-rDMacl1FDjw-unsplash.jpg';


const App = () => {
  const webContainerStyle = {
    height: '100vh',
  };

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundAttachment: 'fixed',
    backgroundImage: `url(${image})`
  };

  const textContainerStyle = {
    textAlign: 'left',
    padding: '2rem',
    fontSize: '1rem' // Default font size for all screens
  };

  // For medium screens (e.g., tablets)
  textContainerStyle['min-width: 768px and max-width: 1023px'] = {
    fontSize: '1.2rem'
  };

  // For large screens (e.g., desktops)
  textContainerStyle['min-width: 1024px'] = {
    fontSize: '1.5rem'
  };

  return (
    <div style={webContainerStyle}>
      <div style={containerStyle}>
        <div style={textContainerStyle}>
          <About />
          <Skills />
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default App;
